
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({ name: 'Subheading' })
export default class Subheading extends Vue {}
